export const FILL_OPTION = {
  NOW: "now",
  LATER: "later",
} as const;

export type FillOption = (typeof FILL_OPTION)[keyof typeof FILL_OPTION];

export const VISIT_TYPES = {
  INITIAL: "initial-visit",
  FOLLOW_UP: "follow-up-visit",
  COACH: "coach-visit",
  NUTRITION_INITIAL_VISIT: "nutrition-initial-visit",
  NUTRITION_FOLLOW_UP_VISIT: "nutrition-follow-up-visit",
} as const;

export const visitTypeLabels = {
  [VISIT_TYPES.INITIAL]: "Initial Visit",
  [VISIT_TYPES.FOLLOW_UP]: "Follow-Up Visit",
  [VISIT_TYPES.COACH]: "Coach Visit",
  [VISIT_TYPES.NUTRITION_INITIAL_VISIT]: "Nutrition Initial Visit",
  [VISIT_TYPES.NUTRITION_FOLLOW_UP_VISIT]: "Nutrition Follow-Up Visit",
} as const;

/**
 * Mirrors the AppointmentSlotStatus enum the slot endpoints return.
 */
export const SLOT_STATUSES = {
  OPEN: "OPEN",
  BOOKED: "BOOKED",
} as const;

export const slotStatusLabels = {
  [SLOT_STATUSES.OPEN]: "Open",
  [SLOT_STATUSES.BOOKED]: "Booked",
} as const;

export type SwitchVariant = "primary" | "secondary";

export const FILL_SWITCH_OPTIONS = {
  NOW: {
    id: FILL_OPTION.NOW,
    label: "Now",
    secondaryLabel: "Yes",
  },
  LATER: {
    id: FILL_OPTION.LATER,
    label: "Later",
    secondaryLabel: "No",
  },
} as const;
